import { render, staticRenderFns } from "./CoordsPicker.vue?vue&type=template&id=34f35914&"
import script from "./CoordsPicker.vue?vue&type=script&lang=js&"
export * from "./CoordsPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports